// frontend/src/config/notificationRoutes.js
export const resolveNotificationLink = (type, metadata = {}) => {
  const map = {
    member_join_request:    `/derasar/my`,
    member_approved:        `/derasar/my`,
    member_rejected:        `/derasar/browse`,
    family_join_request:    `/family`,
    family_approved:        `/family`,
    family_rejected:        `/family`,
    member_added_to_family: `/family`,
    receipt_created:        `/receipts`,
    offer_created:          `/accounting/offerings`,
    offer_status_changed:   `/accounting/offerings`,
    financial_year_closed:  `/accounting/financial-years`,
    demo_request_submitted: `/super-admin/demo-requests`,
  };
  return map[type] ?? `/dashboard`;
};
